import { render, staticRenderFns } from "./DamageStatusSelect.vue?vue&type=template&id=8c21db08&scoped=true"
import script from "./DamageStatusSelect.vue?vue&type=script&lang=ts"
export * from "./DamageStatusSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c21db08",
  null
  
)

export default component.exports